class FacetDelete extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.state = {
      root: window.theme.category
        ? window.theme.category.stateLayer.state
        : window.theme.searchResults.stateLayer.state,
    }

    this.eventBus = window.theme.category
      ? window.theme.category.eventBus
      : window.theme.searchResults.eventBus
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.handleClick)
  }

  connectedCallback () {
    this.setupListeners()
  }

  handleClick (e) {
    e.preventDefault()

    const facet = this.dataset.facet
    const option = this.dataset.value

    this.eventBus.publish('facets-list:remove-filter', {
      facet,
      option,
    })
  }
}

window.customElements.define('facet-delete', FacetDelete)
